export const GA_CITY_SELECTOR_ACTION = 'City Selection Dropdown/<Click>';
export const GA_GET_ESTIMATE_ACTION = 'Get Estimate Button Click/<Click>';
export const GA_GET_ESTIMATE_ACTION_V2 = 'fe_home_getest_tap';
export const GA_CATEGORY_CARD_ACTION = ' Category Card Click';
export const GA_EXPLORE_FLEET = 'Explore/See our Fleet Button Click';
export const GA_ESTIMATE_CATEGORY_CARD_ACTION = 'Estimate Card Click - ';
export const GA_ESTIMATE_VERTICAL_SWITCH_ACTION =
  'Change Category Switch /<Click>';
export const GA_ESTIMATE_VERTICAL_SWITCH_CATEGORY_ACTION =
  'Change Category Switch from ';
export const GA_FOOTER_PLAYSTORE = 'Google Play button clicked ';
export const GA_FOOTER_APPSTORE = 'App Store button clicked ';
